import axios from "axios";
import clone from "clone";
import FormData from "form-data";
import qs from "query-string";
import ObjectHelper from "./object-helper";

function transformData(data) {
  if (data) {
    var result = data;

    if (typeof data === "object" && !(data instanceof FormData)) {
      // Make sure that we don't modify original data
      result = clone(data);
      ObjectHelper.encodeDates(result);
      result = JSON.stringify(result);
    }

    return result;
  }
}

function transformResult(data) {
  if (data) {
    ObjectHelper.parseDates(data);
    return data;
  }
}

function makeRequest(method, url, data) {
  const formatJson = url.endsWith("/") ? "?format=json" : "&format=json";
  return axios({
    method: method,
    url: url,
    data: data,
    params: method === "get" ? data : undefined,
    transformRequest: function(data, headers) {
      if (data) {
        return transformData(data);
      }
    },
    transformResponse: function(data, headers) {
      return data && transformResult(JSON.parse(data));
    },
    paramsSerializer: qs.stringify,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: "csrftoken",
    headers: {
      "Content-Type":
        data instanceof FormData
          ? `multipart/form-data; boundary=${data._boundary}`
          : "application/json"
    },
    auth: {
      username: process.env.SSO_AUTH_USERNAME,
      password: process.env.SSO_AUTH_PASSWORD
    },
    withCredentials: false
  }).catch(function(error) {
    console.error("error", error);
    console.error("Request URL", error.config.url);
    console.error("Response Data", JSON.stringify(error.response.data));
    console.error("Request Data", error.config.data);
  });
}

export var dApi = {
  post: function(url, data) {
    return makeRequest("post", url, data);
  },
  get: function(url, params) {
    const _params = clone(params);
    ObjectHelper.encodeDates(_params);
    return makeRequest("get", url, _params);
  },
  patch: function(url, data) {
    return makeRequest("patch", url, data);
  },
  put: function(url, data) {
    return makeRequest("put", url, data);
  },
  delete: function(url) {
    return makeRequest("delete", url);
  }
};



// WEBPACK FOOTER //
// ./src/components/login/utils/d-api.js